(() => {
  try {
    if (window.location.hostname !== 'checkout.crg.co.jp') return;

    const {pathname, search, hash} = window.location;

    if (pathname === '/collections/frontpage' || pathname === '/collections/frontpage/') {
      window.location.replace('https://ec.crg.co.jp/collections/all?view=crg3&page=1' + hash);
      return;
    }

    if (pathname.indexOf('/policies/') !== 0) return;

    window.location.replace('https://ec.crg.co.jp' + pathname + search + hash);
  } catch (_error) {
    return;
  }
})();
